import { render, staticRenderFns } from "./videoConfSectionHeaderDefault.vue?vue&type=template&id=8e2561e0&scoped=true&lang=pug&"
import script from "./videoConfSectionHeaderDefault.vue?vue&type=script&lang=js&"
export * from "./videoConfSectionHeaderDefault.vue?vue&type=script&lang=js&"
import style0 from "./videoConfSectionHeaderDefault.vue?vue&type=style&index=0&id=8e2561e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2561e0",
  null
  
)

export default component.exports